module.exports = __webpack_public_path__ + "img/5.81b81f0d.png";